import boardLayoutConfig from '../config/rightRailBoardLayout.json'
import { normalizeTierId } from '../config/PricingConfig'
import { testingOverrideAllowsAllFeatures } from '../config/testingOverrides'

export type BoardTileKey =
  | 'AI_MAGIC'
  | 'DASHBOARD'
  | 'OVERVIEW'
  | 'CALENDAR'
  | 'MEETINGS'
  | 'CHAT'
  | 'TODOS'
  | 'CHECKLISTS'
  | 'FORMS'
  | 'DESIGN'
  | 'UPLOAD'
  | 'INVITES'
  | 'LEDGER'
  | 'ANALYSIS'
  | 'REPORTS'
  | 'LINK'
  | 'STOCK'
  | 'CLIENTS'
  | 'TIMESHEETS'
  | 'BUDGET'
  | 'QUOTA'
  | 'TEACHING'
  | 'TRAINING'
  | 'CONSTRUCTION'
  | 'HOSPITAL'
  | 'SITES'
  | 'DELIVERY'
  | 'SHOPS'
  | 'STAYS'
  | 'JOBS'
  | 'CLINICS'
  | 'PLANT'
  | 'FITNESS'
  | 'AUTOMATE'
  | 'MANAGE'
  | 'SETTINGS'
  | 'RAID'
  | 'FOCUS'

export type BoardRailLayoutVariant = keyof typeof boardLayoutConfig

const BOARD_LAYOUTS = boardLayoutConfig as Record<BoardRailLayoutVariant, BoardTileKey[][]>

export const getBoardRailLayoutVariant = (
  plan: unknown,
  overrideAllFeatures = testingOverrideAllowsAllFeatures(),
): BoardRailLayoutVariant => {
  if (overrideAllFeatures) return 'GROWTH_PLUS'
  const tier = normalizeTierId(plan)
  if (tier === 'FREE_TIER') return 'FREE'
  if (tier === 'ESSENTIAL_TIER') return 'ESSENTIAL'
  return 'GROWTH_PLUS'
}

export const getBoardRailRows = (
  plan: unknown,
  overrideAllFeatures = testingOverrideAllowsAllFeatures(),
): BoardTileKey[][] => BOARD_LAYOUTS[getBoardRailLayoutVariant(plan, overrideAllFeatures)]
